/**
 * The situation a path and the picked task make. ONE rule, two senders: the
 * Line's context door (useLine, while a line is open) and the screen beacon
 * (ScreenBeacon, always; spec 2026-09-18 R-L1). The toast drop reads it too, so
 * what the client mutes is exactly what it told the server it was looking at.
 */
import { destinationOfPath } from "@bash/shared";

/** The task page updates its URL with history.replaceState, so the router's pathname can still read a bare /task while a conversation is on screen. */
export const onTaskRoute = (pathname: string): boolean => /^\/task(\/|$)/.test(pathname);

/**
 * The DESTINATION the path is on (spec 2026-09-17 5.3), and the task only where
 * it is what they are looking at (R-P-8: a selectedTaskId outlives the page it
 * was picked on).
 */
export function contextOf(
  pathname: string,
  selectedTaskId: string | null
): { view?: string; activeTaskId?: string } {
  const view = destinationOfPath(pathname)?.id;
  const activeTaskId =
    onTaskRoute(pathname) && selectedTaskId ? selectedTaskId : undefined;
  return { ...(view ? { view } : {}), ...(activeTaskId ? { activeTaskId } : {}) };
}

export const contextKey = (c: { view?: string; activeTaskId?: string }): string =>
  `${c.view ?? ""}|${c.activeTaskId ?? ""}`;
